import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user.service';
import { ReferralService } from '../../services/referral.service';

/**
 * Component for viewing referral data for a task.
 */
@Component({
	selector: 'workflow-task-referral-properties',
	templateUrl: './task-referral-properties.component.html',
	styleUrl: './task-referral-properties.component.css'
})
export class TaskReferralPropertiesComponent implements OnInit {
	@Input() taskData: any;

	LOCALIZATION: any;

	referrals: any[] = [];
	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private userService: UserService,
		private referralService: ReferralService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadReferrals(this.taskData.taskId);
	}
	
	/**
	 * Fetches the referral data for the task.
	 */
	loadReferrals(tid: number): void {
		this.inprogress = true;
		
		this.referralService.getReferralsForTask(tid).then(
			(response: any) => {
				this.referrals = response;
			    this.inprogress = false;
			},
			(err: any) => {
				console.error("Failed loading task referral data", err);
			    this.inprogress = false;
			}
		);		
	}	
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
